import angular from 'angular';

import errors from './config/errorcodes.conf';
import routing from './report-subscriptions-routing-module';
import page from './containers/page/report-subscriptions-page-module';
import './components/management/sftp/sftp-component';
import './components/unsubscribe-confirmation/unsubscribe-component';

export default angular.module('report-subscriptions', [errors.name, routing.name, page.name, 'sftp-management', 'unsubscribe-confirmation']);



// WEBPACK FOOTER //
// ./src/modules/report-subscriptions/report-subscriptions-module.js